'use client';
import cn from 'classnames';
import { ReactNode } from 'react';

import Text from '../Text/Text';

import './StripeElement.style.scss';

type StripeElementProps = {
  className?: string;
  children?: ReactNode;
  error?: string | null;
  label?: string;
};

function StripeElement(props: StripeElementProps) {
  const { className = '', children, error = '', label } = props;

  return (
    <div className={cn('StripeElement', className)}>
      <Text
        className='StripeElement-label'
        variant='title-xxs-500'
      >
        {label}
      </Text>
      {children}

      {error && <Text className='StripeElement-error-text'>{error}</Text>}
    </div>
  );
}

export default StripeElement;
